export enum EUserRole {
    AdminCustomer = 'admin:customer',
    SuperAdminCustomer = 'super:admin:customer',
    Approver = 'approver:customer',
    PayrollManager = 'payroll:manager:customer',
    None = 'None '
}
